// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__34-3s","modalForm":"UpgradeEpcsModal_modalForm__Y6DML","modalFooter":"UpgradeEpcsModal_modalFooter__31yHc"};